import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContadorProposicaoComponent } from './contador-proposicao.component';

@NgModule({
  imports: [CommonModule, ContadorProposicaoComponent],
  exports: [ContadorProposicaoComponent],
})
export class ContadorProposicaoModule {}
